__webpack_require__.p = "https://digiquote.io/";